module.exports = __webpack_public_path__ + "img/copy.b0e3afcb.svg";